import {
  ArrowRightOutlined,
  InfoCircleTwoTone,
  InfoOutlined, PlusCircleTwoTone
} from '@ant-design/icons';
import {
  Descriptions,
  Empty,
  Tabs, Tooltip, Typography
} from 'antd';
import Item from 'antd/lib/list/Item';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import allActions from '../../../../../actions';
import { getLongText } from '../../../../../actions/MaterialDetailsDomain/LoadingKeys';
import Loading from '../../../../../components/loading/Loading';
import PlannedOrdersContext from '../../../../../contexts/plannedOrdersContext';
import { COMMENT_TYPE } from '../../../../../utils/GlobalConstants';
import '../SummaryStyle.css';
import CommentsContainer from './CommentsContainer';

const { TabPane } = Tabs;
const { Paragraph } = Typography;

function CommentSection({
  data, expandLongText, loading, classification, tableStyle, SAPwritebackAuthorized,
}) {
  const [activeKey, setActiveKey] = useState('material_memo');
  const defaultTab = useSelector(
    (state) => state.commonState?.userSettings?.COMMENT_SECTION_DEFAULT_TAB,
  );
  const { plant, material } = useParams();
  const dispatch = useDispatch();
  const { updatePlannedOrders } = useContext(PlannedOrdersContext);
  const labelStyle = {
    fontSize: '12px',
    height: '5px',
    padding: '0px 4px',
    width: '40%',
  };

  useEffect(() => {
    setActiveKey(defaultTab ?? 'material_memo');
  }, [defaultTab]);

  const updateLastChecked = () => {
    dispatch(allActions.SapAPIActions.activateLastChecked(plant, material));
  };

  const content = (key) => {
    if ((key === 'material_memo' && loading?.MRP) || loading[getLongText]) {
      return (
        <div style={{ width: '100%' }}>
          <Loading />
        </div>
      );
    }

    if (key === 'Pl_Ord_Txt') {
      return (
        <div style={{ height: '14vh', overflowY: 'auto' }}>
          <Descriptions
            column={1}
            bordered
            labelStyle={labelStyle}
            contentStyle={{
              fontSize: '12px',
              height: '5px',
              padding: '0px 4px',
              width: '50ch',
            }}
          >
            <Item label="Quantity">
              <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                {data?.CC_PLANNED_ORDER_QTY || '-'}
                {' '}
                <div
                  style={{
                    border: '0.5px solid var(--monetary-impact-positive)',
                    borderRadius: '5% 5%',
                    color: 'var(--neutral--100)',
                    backgroundColor: 'var(--monetary-impact-positive)',
                    marginLeft: '10px',
                    cursor: 'pointer',
                    width: 'fit-content',
                  }}
                  onClick={() => updatePlannedOrders([{ materialID: data.MATERIAL_TYPE_SAP_ID, plantID: data.PLANT_FACILITY_SAP_ID }])}
                >
                  <Tooltip title="Convert Planned Order to Purchase Requisition">
                    <ArrowRightOutlined
                      style={{
                        fontSize: '16px',
                        boxSizing: 'border-box',
                        color: 'var(--neutral--100)',
                        fontWeight: 'bold',
                      }}
                    />
                    {' '}
                    Pur.Req.
                  </Tooltip>
                </div>
              </div>
            </Item>
            <Item label="Status">
              <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr auto',
                alignItems: 'center',
                gap: '4px',
                width: '100%',
              }}
              >
                <p style={{
                  whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', margin: '0',
                }}
                >
                  {data?.PLANNED_ORDER_STATUS}
                </p>
                <Tooltip title={data?.PLANNED_ORDER_STATUS}>
                  <InfoCircleTwoTone />
                </Tooltip>
              </div>
            </Item>
            <Item label="Analysis">
              <div style={{ textAlign: 'center' }}>
                <Tooltip title={<pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>{data?.PLANNED_ORDER_ANALYSIS_FULL_TEXT}</pre>}>
                  {data?.PLANNED_ORDER_ANALYSIS}
                </Tooltip>
                {' '}
                <Tooltip title={<pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>{data?.PLANNED_ORDER_ANALYSIS_FULL_DESCR}</pre>}>
                  <InfoCircleTwoTone />
                </Tooltip>
              </div>
            </Item>
            <Item label="Last Checked">
              <div style={{ textAlign: 'center' }}>
                {data?.LastCheckedDate}
                <span style={{
                  border: '0.5px solid var(--monetary-impact-positive)',
                  borderRadius: '25% 25%',
                  backgroundColor: 'var(--monetary-impact-positive)',
                  marginLeft: '10px',
                }}
                >
                  <Tooltip title="Update Last Checked Date">
                    <InfoOutlined
                      style={{
                        fontSize: '18px',
                        color: 'var(--neutral--100)',
                        fontWeight: 'bold',
                        rotate: '40deg',
                      }}
                      onClick={() => updateLastChecked()}
                    />
                  </Tooltip>
                </span>
              </div>
            </Item>
          </Descriptions>
          <Paragraph className="commentParagaph" style={{ paddingTop: '10px' }}>
            {data?.[key] ?? ''}
          </Paragraph>
        </div>
      );
    }
    if (data?.[key]) {
      return (
        <Paragraph className="commentParagaph">
          {data[key]}
        </Paragraph>
      );
    }
    return (
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} style={{ fontSize: '12px' }} description="No comments found" />
    );
  };

  const getTabColor = (hasItems, key) => {
    if (activeKey === key) {
      return 'var(--contrast-color)';
    }
    if (hasItems) {
      return 'var(--neutral--400)';
    }
    return 'var(--disabled-tabs)';
  };

  const longTextTab = (key, title, titleText) => (
    <TabPane tab={<div className="tabTitle" style={{ color: getTabColor(data?.[key], key) }}>{title}</div>} key={key}>
      <>
        <div className={data?.[key] ? 'commentContainer' : 'commentContainerEmpty'}>
          {content(key)}
        </div>
        <div className="commentContainerButton">
          {(data?.[key] || ((key === 'material_memo' || key === 'Pl_Ord_Txt') && SAPwritebackAuthorized)) && (
            <Tooltip title={key === 'material_memo' && SAPwritebackAuthorized ? 'View full text / edit material memo' : 'View full text'}>
              <PlusCircleTwoTone style={{ height: '2vh' }} onClick={() => expandLongText(key, titleText)} />
            </Tooltip>
          )}
        </div>
      </>
    </TabPane>
  );

  const classificationTab = () => {
    const classificationKeys = Object.keys(classification).filter((x) => x !== 'OLD_STATOIL_ARTICLECODE' && x !== 'MATERIAL_TYPE_SAP_ID');
    const items = classificationKeys.map((x) => <Item key={x} label={x}>{classification[x]}</Item>);
    return (
      <TabPane
        tab={(
          <div className="tabTitle" style={{ color: getTabColor(items.length > 0, 'classification') }}>
            Class
            <br />
            data
          </div>
        )}
        key="classification"
      >
        <div style={{ height: '14vh', overflowY: 'auto' }}>
          <Descriptions
            column={1}
            bordered
            labelStyle={tableStyle}
            contentStyle={tableStyle}
          >
            {items}
          </Descriptions>
        </div>
      </TabPane>
    );
  };

  const iotaCommentTab = () => (
    <TabPane
      tab={(
        <div className="tabTitle" style={{ color: getTabColor(data?.iotaComment, 'IOTAComments') }}>
          {'IOTA '}
          <br />
          {' memo'}
        </div>
      )}
      key="IOTAComments"
    >
      <CommentsContainer
        type={COMMENT_TYPE.IOTA}
        data={data}
        expandLongText={expandLongText}
      />
    </TabPane>
  );

  const warehouseCommentTab = () => (
    <TabPane
      tab={(
        <div className="tabTitle" style={{ color: getTabColor(data?.warehouseComment, 'WarehouseComments') }}>
          {'Whs '}
          <br />
          {' memo'}
        </div>
      )}
      key="WarehouseComments"
    >
      <CommentsContainer
        type={COMMENT_TYPE.WAREHOUSE}
        data={data}
        expandLongText={expandLongText}
      />
    </TabPane>
  );

  const changeActiveTab = (key) => {
    setActiveKey(key);
  };

  return (
    !loading
      ? <Loading text="Loading long text..." spinning />
      : (
        <div>
          <div className="commentLayout">
            <Tabs
              size="small"
              type="card"
              onChange={changeActiveTab}
              activeKey={activeKey}
            >
              {longTextTab('material_memo', (
                <div>
                  {'Material '}
                  <br />
                  {' memo'}
                </div>),
              'Material memo')}
              {longTextTab('Pl_Ord_Txt', (
                <div>
                  Planned
                  <br />
                  Order
                </div>),
              'Planned Order Text')}
              {longTextTab('POtext', (
                <div>
                  {'PO '}
                  <br />
                  {' text'}
                </div>),
              'PO Text')}
              {longTextTab('internal_comment', (
                <div>
                  {'Internal '}
                  <br />
                  {' comment'}
                </div>),
              'Internal comment')}
              {classificationTab()}
              {iotaCommentTab()}
              {warehouseCommentTab()}
            </Tabs>
          </div>
        </div>
      )
  );
}

export default CommentSection;
CommentSection.defaultProps = {
  data: {},
  loading: {},
  classification: {},
};
CommentSection.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
  expandLongText: PropTypes.func.isRequired,
  loading: PropTypes.objectOf(PropTypes.bool),
  classification: PropTypes.objectOf(PropTypes.any),
  tableStyle: PropTypes.objectOf(PropTypes.any).isRequired,
  SAPwritebackAuthorized: PropTypes.bool.isRequired,
};
